export default {"src":"/_next/static/media/yogurt.507915f9.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};